import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cur",
  "use": "icon-cur-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cur\"><path fill=\"#333333\" d=\"M918.528 841.728L727.04 995.328 513.024 723.968 373.76 896 105.472 28.672 900.096 471.04 702.464 573.44l216.064 268.288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol